import { useState, useEffect, useReducer, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import './style.css';
import Explore from './Explore.js';
import FavoritesPage from './FavoritesPage.js';
import Home from './Home.js';
import Navbar from './Navbar.js';
import Login from './Login.js';
// import NewAccount from './NewAccount.js';

function App() {
  return ( 
    <div className="App">
      <Router>
        <Navbar/>
        <Routes>
          <Route path="/" exact element={<Home/>} />
          <Route path="/explore" element={<Explore/>} />
          <Route path="/favorites" element={<FavoritesPage/>} />
          <Route path="/login" element={<Login/>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
